import { render, staticRenderFns } from "./DamageReport.vue?vue&type=template&id=523c4b5e&"
import script from "./DamageReport.vue?vue&type=script&lang=js&"
export * from "./DamageReport.vue?vue&type=script&lang=js&"
import style0 from "./DamageReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports